module.exports = __webpack_public_path__ + "static/logo-b80f98a0f8a6d6dcb7d1cc2d6984bd9c.svg";